export default __webpack_public_path__ + "static/media/globe.c603b966.png";